/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversion_Error_Unsupported_Language_UnknownInputs */

const en_conversion_error_unsupported_language_unknown = /** @type {(inputs: Conversion_Error_Unsupported_Language_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents in this language are not supported yet.`)
};

const es_conversion_error_unsupported_language_unknown = /** @type {(inputs: Conversion_Error_Unsupported_Language_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los documentos en este idioma aún no son compatibles.`)
};

/**
* | output |
* | --- |
* | "Documents in this language are not supported yet." |
*
* @param {Conversion_Error_Unsupported_Language_UnknownInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const conversion_error_unsupported_language_unknown = /** @type {((inputs?: Conversion_Error_Unsupported_Language_UnknownInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversion_Error_Unsupported_Language_UnknownInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_conversion_error_unsupported_language_unknown(inputs)
	return en_conversion_error_unsupported_language_unknown(inputs)
});